import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ListaService} from '../../../../_services/lista.service';
import {NavService} from '../../../../_services/_nav.service';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {AppSettingService} from '../../../../_services/app-setting.service';
import {ProductoPasarelaTarifaService} from '../../../../_services/producto-pasarela-tarifa.service';
import {ProductoPasarelaTarifa} from '../../../../_models/producto-pasarela-tarifa';
import {CanalService} from '../../../../_services/canal.service';
import {forkJoin, Observable} from 'rxjs';
import {Listas} from '../../../../_enums/enum';
import {ProductoPasarela} from '../../../../_models/producto-pasarela';
import {slideCollapseAnimation} from '../../../../utils/slide-collapse.animation';
import {CustomValidators} from '../../../../_helpers/formularios-reactivos/custom.validators';

@Component({
  selector: 'app-producto-pasarela-tarifas',
  templateUrl: './producto-pasarela-tarifas.component.html',
  styleUrl: './producto-pasarela-tarifas.component.css',
  animations: [slideCollapseAnimation],
})
export class ProductoPasarelaTarifasComponent implements OnInit {
  @Input() isDetail: boolean = false;
  @Input() productoPasarela: ProductoPasarela;
  isLoading: boolean = true;
  records: ProductoPasarelaTarifa[] = [];
  channels: SelectItem[] = [];
  paymentMethods: SelectItem[] = [];
  cols: any[] = [];
  rows: number = 10;

  showForm: boolean = false;
  form: FormGroup;
  submitted: boolean = false;
  saving: boolean = false;
  cdKey: string = 'producto-pasarela-tarifas';

  constructor(
    private fb: FormBuilder,
    private service: ProductoPasarelaTarifaService,
    private listService: ListaService,
    private canalService: CanalService,
    private navService: NavService,
    private confirmationService: ConfirmationService,
    private appSettingService: AppSettingService,
  ) {
  }

  ngOnInit(): void {
    this.cols = [
      {field: 'nombreCanal', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_CANAL'), sort: false},
      {field: 'nombreMedioPago', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_MEDIO_PAGO'), sort: false},
      {field: 'tarifaTrxVentaPorcentaje', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_TARIFA_VENTA'), sort: false},
      {field: 'tarifaTrxIndividual', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_TARIFA_INDIVIDUAL'), sort: false},
      {field: 'montoMinimoTrx', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_MONTO_MINIMO'), sort: false},
      {field: 'montoMaximoTrx', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_MONTO_MAXIMO'), sort: false},
      {field: 'montoMaximoMes', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_MONTO_MAXIMO_MES'), sort: false},
      {field: 'limiteTrxDiario', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_LIMITE_DIARIO'), sort: false},
      {field: 'limiteTrxMes', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_LIMITE_MES'), sort: false},
      {
        field: 'indicadorAplicaTarifaEspecial',
        header: this.navService.buscarMensaje('PRODUCTO_PASARELA_TARIFAS.LBL_APLICA_TARIFA_ESPECIAL'),
        sort: false
      },
    ];

    if (!this.isDetail) {
      this.cols.push({field: 'acciones', header: this.navService.buscarMensaje('LBL_ACCIONES'), sort: false});
    }

    this.loadData();
  }

  loadData(): void {
    forkJoin([
      this.service.getByIdProductoPasarelaEnabled(this.productoPasarela?.idProductoPasarela),
      this.canalService.listadoCanalesHabilitados(),
      this.listService.getMasterDetails(Listas.LISTAS_TIPOS_MEDIOS_PAGOS),
    ]).subscribe({
      next: ([records, channels, paymentMethods]) => {
        this.records = records;
        this.channels = channels.map(e => ({label: e.nombre, value: e.idCanal}));
        this.paymentMethods = paymentMethods.map(e => ({label: e.nombre, value: e.idLista}));
        this.isLoading = false;
      },
    });
  }

  loadRecords(): void {
    this.isLoading = true;
    this.service.getByIdProductoPasarelaEnabled(this.productoPasarela?.idProductoPasarela).subscribe({
      next: (records) => {
        this.records = records;
        this.isLoading = false;
        this.form?.updateValueAndValidity();
      },
    });
  }

  onCreateOrEdit(record?: ProductoPasarelaTarifa): void {
    this.buildForm(record);
  }

  onDelete(record: ProductoPasarelaTarifa): void {
    this.confirmationService.confirm({
      key: this.cdKey,
      header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
      message: this.navService.buscarMensaje('MSG_ELIMINARCAMBIOS'),
      accept: () => {
        this.saving = true;
        record.indicadorHabilitado = false;
        this.service.update(record).subscribe({
          next: () => {
            this.navService.setMesage(2);
            this.saving = false;
            if (this.form && this.f.idProductoPasarelaTarifa.value === record.idProductoPasarelaTarifa) {
              this.showForm = false;
            }
            this.loadRecords();
          },
          error: () => {
            this.navService.setMesage(3);
            this.saving = false;
          },
        });
      },
    });
  }

  onCancel(): void {
    if (this.isFormDirty) {
      this.confirmationService.confirm({
        key: this.cdKey,
        header: this.navService.buscarMensaje('LBL_CAMBIOS_SIN_GUARDAR'),
        message: this.navService.buscarMensaje('MSG_CAMBIOS_SIN_GUARDAR'),
        accept: () => this.showForm = false,
      });
    } else {
      this.showForm = false;
    }
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }

    this.saving = true;
    const record: ProductoPasarelaTarifa = this.form.getRawValue();
    const request: Observable<ProductoPasarelaTarifa> = this.isNewRecord ? this.service.create(record) : this.service.update(record);
    request.subscribe({
      next: () => {
        this.navService.setMesage(this.isNewRecord ? 1 : 2);
        this.saving = false;
        this.showForm = false;
        this.loadRecords();
      },
      error: () => {
        this.navService.setMesage(3);
        this.saving = false;
      },
    });
  }

  get percentageSymbol(): string {
    return ` ${this.appSettingService.percentageSymbol}`;
  }

  get moneySymbol(): string {
    return `${this.appSettingService.simboloDinero} `;
  }

  get isNewRecord(): boolean {
    return !this.f.idProductoPasarelaTarifa.value;
  }

  get isFormDirty(): boolean {
    return !!this.form?.dirty;
  }

  get f() {
    return this.form.controls;
  }

  private buildForm(record?: ProductoPasarelaTarifa): void {
    this.form = this.fb.group({
      idProductoPasarela: [record ? record.idProductoPasarela : this.productoPasarela?.idProductoPasarela],
      idProductoPasarelaTarifa: [record ? record.idProductoPasarelaTarifa : null],
      idCanal: [record ? record.idCanal : null, [Validators.required]],
      idMedioPago: [record ? record.idMedioPago : null, [Validators.required]],
      tarifaTrxVentaPorcentaje: [record ? record.tarifaTrxVentaPorcentaje : null, [Validators.required]],
      tarifaTrxIndividual: [record ? record.tarifaTrxIndividual : null, [Validators.required]],
      montoMinimoTrx: [record ? record.montoMinimoTrx : null, [Validators.required]],
      montoMaximoTrx: [record ? record.montoMaximoTrx : null, [Validators.required]],
      montoMaximoMes: [record ? record.montoMaximoMes : null, [Validators.required]],
      limiteTrxDiario: [record ? record.limiteTrxDiario : null, [Validators.required]],
      limiteTrxMes: [record ? record.limiteTrxMes : null, [Validators.required]],
      indicadorAplicaTarifaEspecial: [record ? record.indicadorAplicaTarifaEspecial : false],
      indicadorHabilitado: [record ? record.indicadorHabilitado : true],
    });

    if (this.isNewRecord) {
      this.form.setValidators(CustomValidators.uniqueCombination<ProductoPasarelaTarifa>(['idCanal', 'idMedioPago'], () => this.records));
    } else {
      this.f.idCanal.disable();
      this.f.idMedioPago.disable();
    }

    this.submitted = false;
    this.showForm = true;
  }

}
